<template>
    <div id="chart" v-if="dataObj">
        <apexchart :options="chartOptions" :series="series"></apexchart>
    </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
export default {
    name:'apexChartAreaCom',
    props:['dataObj', 'labelX'],
    components: {
        apexchart: VueApexCharts,
    },
    data(){
        return{
            series: [],
            chartOptions: {
                colors: this.dataObj.colors,
                chart: {
                    height: 100,
                    // width: 100,
                    type: 'line',
                    sparkline: {
                        enabled: true
                    },
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'straight'
                },
                title: {
                    align: 'left'
                },
                subtitle: {
                    align: 'left'
                },
                labels: [],
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    }
                },
                xaxis: {
                    categories: ['']
                },
                yaxis: {
                    opposite: true
                },
                legend: {
                    horizontalAlign: 'left'
                },
            },
        }
    },
    watch:{
        dataObj:function(val){
            const newSeries = [
                {
                    name: this.dataObj.name,
                    data: this.dataObj.data,
                },
            ];
            this.series = newSeries;
            this.chartOptions = {
                ...this.chartOptions, 
                ...{
                    xaxis: {
                        categories:this.dataObj.labels,
                    }
                }
            }
        }
    }
}
</script>